class Constants {
    AppVariables =
        {
            ModalDivId: "modal",
            ImageLoaderPath: "/assets/svg-loaders/bars.svg",
            SpinnerId: "spinner"
        }
}
export { Constants }
